const routes = {
  path: "/fitting",
  name: "Fitting",
  component: () =>
    import(/* webpackChunkName: "fitting" */ "@/views/fitting/Main"),
  children: [
    {
      path: "fittinglist",
      alias: "",
      name: "FittingList",
      component: () =>
        import(/* webpackChunkName: "fitting" */ "@/views/fitting/FittingList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "피팅현황",
        step: ["피팅관리", "피팅현황"],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "fittingswinglist/:fittingno",
      name: "FittingSwingList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/FittingSwingList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "피팅 스윙 리스트",
        step: ["피팅관리", "피팅 스윙 리스트"],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "fittinganswerview/:fitreqno",
      name: "FittingAnswerView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/FittingAnswerView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "피팅 내역",
        menu_num: 7,
        sub_menu_num: 71,
        step: ["피팅관리", "피팅 내역"],
      },
    },
    {
      path: "salelist",
      alias: "",
      name: "SaleList",
      component: () =>
        import(/* webpackChunkName: "fitting" */ "@/views/fitting/SaleList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "판매현황",
        step: ["피팅관리", "판매현황"],
        menu_num: 7,
        sub_menu_num: 72,
      },
    },
    {
      path: "saleview/:fitansno",
      name: "SaleView",
      component: () =>
        import(/* webpackChunkName: "tournament" */ "@/views/fitting/SaleView"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "판매 내역",
        menu_num: 7,
        sub_menu_num: 72,
        step: ["피팅관리", "판매 내역"],
      },
    },

    {
      path: "customerlist",
      alias: "",
      name: "CustomerList",
      category: 0,
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/CustomerList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "A/S현황",
        menu_num: 7,
        sub_menu_num: 73,
        step: ["피팅관리", "A/S현황"],
      },
    },
    {
      path: "customerview/:noticeno",
      name: "CustomerView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/CustomerView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "상세보기",
        menu_num: 7,
        sub_menu_num: 73,
        step: ["피팅관리", "A/S 상세보기"],
      },
    },
    {
      path: "customerwrite/:noticeno?",
      name: "CustomerWrite",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/CustomerWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: "A/S 등록",
        menu_num: 7,
        sub_menu_num: 73,
        step: ["피팅관리", "A/S 등록"],
      },
    },
  ],
};

export default routes;
